import AccountSelect from "../AccountSelect";
import TagField from "./TagField";
import CompanySelect from "../CompanySelect";
import PersonSelect from "../PersonSelect";
import CategorySelect from "../CategorySelect";
import BoolToggle from "../BoolToggle";
import { Col, DatePicker, Divider, Form, Input, Row, Tooltip } from 'antd';
import ProjectSelect from '../ProjectSelect';
import PeriodSelect from '../PeriodSelect';
import { EditOutlined } from '@ant-design/icons';

const { TextArea } = Input;

/**
 * Field group for personal-mode orgs (config.single_date).
 *
 * Sibling of DefaultFields / TaxFields / TransferFields. Kept separate rather than
 * branching inside DefaultFields so the company form stays byte-identical.
 *
 * Differences from DefaultFields:
 *   - one date ("Datum"), written to date_to_be_paid; the invoice/service dates
 *     are invoice concepts and stay NULL (enforced in Intent.save()).
 *   - no "Izdano" toggle -- issuance is meaningless without invoices.
 *   - no invoice number and no project splits.
 */

const OverrideLabel = ({ label, field, overriddenFields }) => (
  <span>
    {label}
    {overriddenFields?.includes(field) && (
      <Tooltip title="Vrednost je bila ročno spremenjena.">
        <EditOutlined style={{ color: '#1677ff', marginLeft: 4 }} />
      </Tooltip>
    )}
  </span>
);

const PersonalFields = ({
  isIntentEditable,
  repeatPeriod,
  typeValue,
  massEdit,
  overriddenFields,
  isEdit,
  activeEditDimension,
  tagRuleHint,
  onClearTagRuleHint,
  onCreateTagRule,
}) => {
  const wizardFieldsDisabled = isEdit && activeEditDimension === 'split';

  return (
    <>
      {isIntentEditable && (
        <>
          {(typeValue != null || massEdit) && (
            <Row>
              <Col span={24}>
                <Form.Item
                  name="date_to_be_paid"
                  label={<OverrideLabel label="Datum" field="date_to_be_paid" overriddenFields={overriddenFields} />}
                  rules={massEdit ? [] : [{ required: true, message: 'Prosim vnesite datum' }]}
                  help={<small>Datum transakcije.</small>}
                >
                  <DatePicker style={{ width: '100%' }} getPopupContainer={(trigger) => trigger.parentElement} />
                </Form.Item>
              </Col>
            </Row>
          )}

          <Row gutter={[12, 12]} style={{ marginTop: 12, marginBottom: 24 }}>
            <Col span={12}>
              <Form.Item name="is_paid" initialValue={massEdit ? null : false} noStyle>
                <BoolToggle label="Plačano" allowNull={massEdit} />
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          <Row>
            <Col span={24}>
              <Form.Item
                name="title"
                label={<OverrideLabel label="Naziv" field="title" overriddenFields={overriddenFields} />}
                rules={[{ required: true, message: 'Prosim vnesite naziv' }]}
              >
                <Input size="large" placeholder="Vnesite naziv" />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item name="descr" rules={[]}>
                <TextArea placeholder={'Opis...'} rows={3} />
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          <Row>
            <Col span={24}>
              <Form.Item name="account" label="Račun">
                <AccountSelect />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <TagField
                tagRuleHint={tagRuleHint}
                onClearTagRuleHint={onClearTagRuleHint}
                onCreateTagRule={onCreateTagRule}
                massEdit={massEdit}
              />
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item name="company" label="Podjetje">
                <CompanySelect />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item name="person" label="Oseba">
                <PersonSelect />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item name="category" label="Kategorija">
                <CategorySelect />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item name="project" label="Projekt">
                <ProjectSelect />
              </Form.Item>
            </Col>
          </Row>

          <Divider />

          {!massEdit && (
            <Row>
              <Col span={12}>
                <Form.Item name="repeat_period" label="Ponavljanje">
                  <PeriodSelect disabled={wizardFieldsDisabled} />
                </Form.Item>
              </Col>
              {repeatPeriod && (
                <Col span={12}>
                  <Form.Item
                    name="repeat_to_date"
                    label="Ponavljaj do"
                    rules={[{ required: true, message: 'Prosim vnesite končni datum ponavljanja' }]}
                  >
                    <DatePicker style={{ width: '100%' }} disabled={wizardFieldsDisabled} getPopupContainer={(trigger) => trigger.parentElement} />
                  </Form.Item>
                </Col>
              )}
            </Row>
          )}
        </>
      )}
    </>
  );
};

export default PersonalFields;
